/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Full_Cod_PullInputs */

const en_happy_full_cod_pull = /** @type {(inputs: Happy_Full_Cod_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclassifying topics…`)
};

const de_happy_full_cod_pull = /** @type {(inputs: Happy_Full_Cod_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themen werden neu klassifiziert…`)
};

/**
* | output |
* | --- |
* | "Reclassifying topics…" |
*
* @param {Happy_Full_Cod_PullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_full_cod_pull = /** @type {((inputs?: Happy_Full_Cod_PullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Full_Cod_PullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_full_cod_pull(inputs)
	return de_happy_full_cod_pull(inputs)
});